/* eslint-disable complexity,camelcase,no-loops/no-loops,max-depth,no-nested-ternary,no-new-func,max-params,no-cond-assign,no-constant-condition */
/**
 * @fileoverview A modified version of the jsgettext library.
 *
 * Copied from http://cvs.berlios.de/cgi-bin/viewcvs.cgi/jsgettext/jsgettext/lib/Gettext.js?revision=1.16 (broken link)
 * The project can be found at http://jsgettext.sourceforge.net/doc/html/Gettext.html
 *
 * Translation data is supplied as a JavaScript object. The format is not well documented, but it's similar to
 * jed format (http://messageformat.github.io/Jed/). One main difference is that plural and singular are reversed.
 *
 * One of the major Indeed modifications is that instead of using english strings as message ids, we save space by
 * using a hash of the english string. GettextBase handles hashing transparently, so the API still takes
 * english strings as input.
 *
 * @suppress {checkVars|checkTypes}
 */

/*
 Pure Javascript implementation of Uniforum message translation.
 Copyright (C) 2008 Joshua I. Miller <unrtst@cpan.org>, all rights reserved

 This program is free software; you can redistribute it and/or modify it
 under the terms of the GNU Library General Public License as published
 by the Free Software Foundation; either version 2, or (at your option)
 any later version.

 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 Library General Public License for more details.

 You should have received a copy of the GNU Library General Public
 License along with this program; if not, write to the Free Software
 Foundation, Inc., 59 Temple Place - Suite 330, Boston, MA 02111-1307,
 USA.
 */

function stringhash(str, salt) {
    var hash = salt;
    var i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }

    // JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    // integers. Since we want the results to be always positive, convert the
    // signed int to an unsigned by doing an unsigned bit shift.
    return hash >>> 0;
}

var Jed = require('./JedPluralForms');

var DefaultLogger = function() {
    this.error = function() {
        // Intentionally blank, don't emit logs if using this logger
    };
};

/**
 * @param args - Paramater object containing arguments to gettext. Valid parameters:
 *                * domain - effectively a "namespace" to use for translations
 *                * locale_data - the actual translation data to use for this instance of gettext
 *                * logger - { error: (string) => void } object that will be called when a translation is not present
 * @constructor
 */
var Gettext = function(args) {
    this.domain = 'messages';
    this.input_locale_data = undefined; // eslint-disable-line no-undefined
    this.locale_data = {};

    // set options
    var options = ['domain', 'locale_data', 'logger'];
    var validatedOptions = {};
    if (this.isValidObject(args)) {
        for (var i in args) {
            for (var j = 0; j < options.length; j++) {
                if (i === options[j]) {
                    // don't set it if it's null or undefined
                    if (this.isValidObject(args[i])) validatedOptions[i] = args[i];
                }
            }
        }
    }

    // Translate all valid options over into the compiled namespace
    if (validatedOptions.domain) {
        this.domain = validatedOptions.domain;
    }
    if (validatedOptions.locale_data) {
        this.input_locale_data = validatedOptions.locale_data;
    }

    this.logger = validatedOptions.logger || new DefaultLogger();

    this.try_parse_locale_data();

    return this;
};

Gettext.context_glue = '\u0004';

Gettext.prototype.try_parse_locale_data = function() {
    // check to see if language is statically included
    if (typeof this.input_locale_data !== 'undefined') {
        // we're going to reformat it, and overwrite the variable
        this.parse_locale_data(JSON.parse(JSON.stringify(this.input_locale_data)));
    }
};

// This takes the bin/po2json'd data, and moves it into an internal form
// for use in our lib, and puts it in our object as:
//  this._locale_data = {
//      domain : {
//          head : { headfield : headvalue },
//          msgs : {
//              msgid : [ msgstr, msgstr_plural ],
//          },
// eslint-disable-next-line complexity
Gettext.prototype.parse_locale_data = function(locale_data) {
    if (typeof this.locale_data === 'undefined') {
        this.locale_data = {};
    }

    // suck in every domain defined in the supplied data
    for (var domain in locale_data) {
        // skip empty specs (flexibly)
        if (!locale_data.hasOwnProperty(domain) || !this.isValidObject(locale_data[domain]))
            continue;
        // skip if it has no msgid's
        var has_msgids = false;
        // eslint-disable-next-line no-unused-vars
        for (var msgid in locale_data[domain]) {
            has_msgids = true;
            break;
        }
        if (!has_msgids) continue;

        // grab shortcut to data
        var data = locale_data[domain];

        // if they specify a blank domain, default to "messages"
        if (domain === '') {
            domain = 'messages';
        }
        // init the data structure
        if (!this.isValidObject(this.locale_data[domain])) this.locale_data[domain] = {};
        if (!this.isValidObject(this.locale_data[domain].head)) this.locale_data[domain].head = {};
        if (!this.isValidObject(this.locale_data[domain].msgs)) this.locale_data[domain].msgs = {};

        var optimized_format = false;
        if (data.hasOwnProperty('') && data[''].hasOwnProperty('salt')) {
            optimized_format = true;
        }

        for (var message_id in data) {
            if (data.hasOwnProperty(message_id)) {
                if (message_id === '') {
                    // The empty string is treated as header data instead of as a regular message
                    var header = data[message_id];
                    for (var head in header) {
                        if (header.hasOwnProperty(head)) {
                            var h = head.toLowerCase();
                            this.locale_data[domain].head[h] = header[head];
                        }
                    }
                } else {
                    if (
                        optimized_format &&
                        (data[message_id].length === 0 || data[message_id][0] !== null)
                    ) {
                        // Add a dummy msgid_plural
                        // This value is never used, but the unoptimized format includes it
                        // TODO: remove this line once backwards compatibility with the unoptimized format is not needed
                        this.locale_data[domain].msgs[message_id] = [null].concat(data[message_id]);
                    } else {
                        this.locale_data[domain].msgs[message_id] = data[message_id];
                    }
                }
            }
        }
    }

    // build the plural forms function
    // eslint-disable-next-line no-redeclare
    for (var domain in this.locale_data) {
        if (
            this.isValidObject(this.locale_data[domain].head['plural-forms']) &&
            typeof this.locale_data[domain].head.plural_func === 'undefined'
        ) {
            // untaint data
            var plural_forms = this.locale_data[domain].head['plural-forms'];
            // eslint-disable-next-line no-useless-escape
            var pf_re = new RegExp(
                '^(\\s*nplurals\\s*=\\s*[0-9]+\\s*;\\s*plural\\s*=\\s*(?:\\s|[-\\?\\|&=!<>+*/%:;a-zA-Z0-9_()])+)',
                'm'
            );
            if (pf_re.test(plural_forms)) {
                //ex english: "Plural-Forms: nplurals=2; plural=(n != 1);\n"
                //pf = "nplurals=2; plural=(n != 1);";
                //ex russian: nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10< =4 && (n%100<10 or n%100>=20) ? 1 : 2)
                //pf = "nplurals=3; plural=(n%10==1 && n%100!=11 ? 0 : n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2)";

                var pf = this.locale_data[domain].head['plural-forms'];
                if (!/;\s*$/.test(pf)) pf = pf.concat(';');
                this.locale_data[domain].head.plural_func = Jed.PF.compile(pf);
            } else {
                throw new Error(
                    'Syntax error in language file. Plural-Forms header is invalid [' +
                        plural_forms +
                        ']'
                );
            }

            // default to english plural form
        } else if (typeof this.locale_data[domain].head.plural_func === 'undefined') {
            this.locale_data[domain].head.plural_func = Jed.PF.compile(
                'nplurals=2; plural=n != 1;'
            );
        } // else, plural_func already created
    }
};

// gettext
Gettext.prototype.gettext = function(msgid) {
    var msgctxt;
    var msgid_plural;
    var n;
    var category;

    return this.dcnpgettext(null, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dgettext = function(domain, msgid) {
    var msgctxt;
    var msgid_plural;
    var n;
    var category;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dcgettext = function(domain, msgid, category) {
    var msgctxt;
    var msgid_plural;
    var n;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

// ngettext
Gettext.prototype.ngettext = function(msgid, msgid_plural, n) {
    var msgctxt;
    var category;

    return this.dcnpgettext(null, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dngettext = function(domain, msgid, msgid_plural, n) {
    var msgctxt;
    var category;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dcngettext = function(domain, msgid, msgid_plural, n, category) {
    var msgctxt;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category, category);
};

// pgettext
Gettext.prototype.pgettext = function(msgctxt, msgid) {
    var msgid_plural;
    var n;
    var category;

    return this.dcnpgettext(null, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dpgettext = function(domain, msgctxt, msgid) {
    var msgid_plural;
    var n;
    var category;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dcpgettext = function(domain, msgctxt, msgid, category) {
    var msgid_plural;
    var n;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

// npgettext
Gettext.prototype.npgettext = function(msgctxt, msgid, msgid_plural, n) {
    var category;

    return this.dcnpgettext(null, msgctxt, msgid, msgid_plural, n, category);
};

Gettext.prototype.dnpgettext = function(domain, msgctxt, msgid, msgid_plural, n) {
    var category;

    return this.dcnpgettext(domain, msgctxt, msgid, msgid_plural, n, category);
};

/**
 * Translation function which handles all possible options.
 * All of the other translation functions are wrappers around this method.
 *
 * @param {string} domain
 * @param {string} msgctxt
 * @param {string} msgid
 * @param {string} msgid_plural
 * @param {number} n
 * @param category - Deprecated - This option is ignored.
 * @returns {string} The translated message, or the original message if no translation exists.
 */
// eslint-disable-next-line no-unused-vars, complexity
Gettext.prototype.dcnpgettext = function(domain, msgctxt, msgid, msgid_plural, n, category) {
    if (!this.isValidObject(msgid)) {
        return '';
    }

    var english_message = msgid;
    var english_message_plural;
    var plural = this.isValidObject(msgid_plural);
    if (plural) {
        english_message_plural = msgid_plural;
    }

    var foundTranslation = this.findTranslation(domain, msgctxt, msgid);
    var trans = foundTranslation.trans;
    var found = foundTranslation.found;
    var domain_used = foundTranslation.domain_used;

    // default to english if we lack a match, or match has zero length
    if (trans.length === 0 || trans[0].length === 0) {
        this.logger.error('msgid="' + english_message + '" was not present');
        trans = [english_message, english_message_plural];
    }

    var translation = trans[0];
    if (plural) {
        var p;
        if (found && this.isValidObject(domain_used.head.plural_func)) {
            p = domain_used.head.plural_func(n);
        } else {
            p = n !== 1 ? 1 : 0;
        }
        if (this.isValidObject(trans[p])) translation = trans[p];
    }

    return translation;
};

/* utility method, since javascript lacks a printf */
Gettext.strargs = function(str, args) {
    // make sure args is an array
    if (args === null || typeof args === 'undefined') {
        args = [];
    } else if (args.constructor !== Array) {
        args = [args];
    }

    // NOTE: javascript lacks support for zero length negative look-behind
    // in regex, so we must step through w/ index.
    // The perl equiv would simply be:
    //    $string =~ s/(?<!\%)\%([0-9]+)/$args[$1]/g;
    //    $string =~ s/\%\%/\%/g; # restore escaped percent signs

    var newstr = '';
    while (true) {
        var i = str.indexOf('%');
        var match_n;

        // no more found. Append whatever remains
        if (i === -1) {
            newstr += str;
            break;
        }

        // we found it, append everything up to that
        newstr += str.substr(0, i);

        // check for escpaed %%
        if (str.substr(i, 2) === '%%') {
            newstr += '%';
            str = str.substr(i + 2);

            // % followed by number
        } else if ((match_n = str.substr(i).match(/^%(\d+)/))) {
            var arg_n = parseInt(match_n[1]);
            var length_n = match_n[1].length;
            if (arg_n > 0 && args[arg_n - 1] !== null && typeof args[arg_n - 1] !== 'undefined')
                newstr += args[arg_n - 1];
            str = str.substr(i + 1 + length_n);

            // % followed by some other garbage - just remove the %
        } else {
            newstr += '%';
            str = str.substr(i + 1);
        }
    }

    return newstr;
};

/* instance method wrapper of strargs */
Gettext.prototype.strargs = function(str, args) {
    return Gettext.strargs(str, args);
};

/* verify that an object exists and is valid */
Gettext.prototype.isValidObject = function(thisObject) {
    if (thisObject === null) {
        return false;
    } else if (typeof thisObject === 'undefined') {
        return false;
    } else {
        return true;
    }
};

/**
 * Find the given translation in the locale data and return the results
 * @param {string | null} domain
 * @param {string | undefined} msgctxt
 * @param {string} msgid
 * @returns {{trans: string[], found: boolean, domain_used: any}}
 */
Gettext.prototype.findTranslation = function(domain, msgctxt, msgid) {
    var domainname = this.isValidObject(domain)
        ? domain
        : this.isValidObject(this.domain)
        ? this.domain
        : 'messages';

    var locale_data = [];
    if (
        typeof this.locale_data !== 'undefined' &&
        this.isValidObject(this.locale_data[domainname])
    ) {
        locale_data.push(this.locale_data[domainname]);
    } else if (typeof this.locale_data !== 'undefined') {
        // didn't find domain we're looking for. Search all of them.
        for (var dom in this.locale_data) {
            locale_data.push(this.locale_data[dom]);
        }
    }

    var trans = [];
    var found = false;
    var domain_used; // so we can find plural-forms if needed
    var isTranslated = false;
    if (locale_data.length) {
        for (var i = 0; i < locale_data.length; i++) {
            var locale = locale_data[i];

            var message_hash = this.isValidObject(msgctxt)
                ? msgctxt + Gettext.context_glue + msgid
                : msgid;
            if (locale.head.hasOwnProperty('salt')) {
                // To save space, translation data is stored using a hash of the message id instead of the raw english string.
                message_hash = stringhash(message_hash, locale.head.salt);
                if (locale.head.hasOwnProperty('id_length')) {
                    message_hash = String(message_hash).substring(0, locale.head.id_length);
                }
            }
            if (this.isValidObject(locale.msgs[message_hash])) {
                // TODO: remove the call to .slice(1) once backwards compatibility with the unoptimized format is not needed
                trans = locale.msgs[message_hash].slice(1); // throw away the msgid_plural
                domain_used = locale;
                found = true;
                // only break if found translation actually has a translation.
                if (trans.length > 0 && trans[0].length !== 0) {
                    isTranslated = true;

                    break;
                }
            }
        }
    }

    return { trans: trans, found: found, domain_used: domain_used, isTranslated: isTranslated };
};

module.exports = Gettext;
